import {
  Button,
  Col,
  ConfigProvider,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Pagination,
  Radio,
  Row,
  Select,
  Table,
  Tag,
} from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useRecoilState } from 'recoil'
import Swal from 'sweetalert2'
import * as XLSX from 'xlsx'
import orderApi from '../../api/order.api'
import promotionApi from '../../api/promotion.api'
import pushApi from '../../api/push.api'
import ContentHeader from '../../components/shared/ContentHeader'
import { userState } from '../../store/user'
import { CustomDateButtonRadioTheme } from '../../styles/CustomAntdTheme'
import styles from '../../styles/sales.module.scss'
import statusUtil from '../../utils/status'

const numberReg = /^[0-9]*$/

const OrderCancelPage = () => {
  const [user, setUser] = useRecoilState(userState)
  const [isLoading, setIsLoading] = useState(false)

  const [cancelStatus, setCancelStatus] = useState({
    cancelRequest: 0,
    cancelComplete: 0,
  })
  const [dateType, setDateType] = useState('1week')
  const [searchOptions, setSearchOptions] = useState({
    searchType: 'paymentCreatedAt',
    searchStatus: 'cancel_request',
    searchOrderId: '',
    searchProductName: '',
    funnel: 0,
    name: '',
    phone: '',
    startDate: dayjs().subtract(7, 'days').startOf('day'),
    endDate: dayjs().endOf('day'),
  })
  const [orderType, setOrderType] = useState('paymentCreatedAt')
  const [orderBy, setOrderBy] = useState('desc')
  const [selectedRowKey, setSelectedRowKey] = useState([])
  const [selectedRow, setSelectedRow] = useState([])
  const [currentPageNumber, setCurrentPageNumber] = useState(1)
  const [totalSize, setTotalSize] = useState(0)
  const [offset, setOffset] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [deliveryCompanyList, setDeliveryCompanyList] = useState([])
  const [totalOrderList, setTotalOrderList] = useState([])
  const [orderList, setOrderList] = useState([])
  const [isCancelRefusalModalOpen, setIsCancelRefusalModalOpen] =
    useState(false)
  const [cancelRefusalReason, setCancelRefusalReason] = useState({
    cancelReason: '상품 배송중',
    cancelReasonDetail:
      '고객님, 취소요청하신 상품이 이미 발송되어, 상품 받으신 후에 반품 및 교환만 가능합니다.',
    deliveryCompany: null,
    trackingNumber: '',
    shipDate: dayjs(),
  })

  const searchDateItems = [
    { searchText: '결제일', searchType: 'paymentCreatedAt' },
    { searchText: '클레임 요청일', searchType: 'cancelRequestAt' },
  ]
  const dateTypeItems = [
    { label: '오늘', value: 'today' },
    { label: '1주일', value: '1week' },
    { label: '1개월', value: '1month' },
    { label: '3개월', value: '3month' },
    { label: '6개월', value: '6month' },
  ]
  const orderStatusItems = [
    { label: '전체', value: 'total' },
    // {label: '입금대기', value: 'ready'},
    // {label: '입금완료', value: 'paid'},
    // {label: '결제실패', value: 'failed'},
    // {label: '결제취소', value: 'cancelled'},
    // {label: '배송준비중', value: 'delivery_ready'},
    // {label: '배송중', value: 'delivery_shipping'},
    // {label: '배송완료', value: 'delivery_complete'},
    // {label: '구매확정', value: 'complete'},
    { label: '취소요청', value: 'cancel_request' },
    // {label: '교환요청', value: 'exchange_request'},
    // {label: '반품요청', value: 'return_request'},
    { label: '취소완료', value: 'cancel_complete' },
    // {label: '교환완료', value: 'exchange_complete'},
    // {label: '반품완료', value: 'return_complete'}
  ]
  const orderPair = {
    paymentCreatedAt: '결제일순',
    orderId: '주문번호순',
    cancelRequestAt: '클레임 요청일순',
  }
  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onSelect: (record, selected) => {
      let editKeyList = []
      let editRowList = []
      if (selected) {
        editRowList = totalOrderList.filter(
          (order) => order.orderId === record.orderId,
        )
        editKeyList = editRowList.map((row) => row.orderDetailId)
      } else {
        editRowList = []
        editKeyList = []
      }
      setSelectedRowKey(editKeyList)
      setSelectedRow(editRowList)
    },
  }
  const columns = [
    {
      title: '주문번호',
      width: 90,
      dataIndex: 'orderId',
      key: 'orderId',
      fixed: 'left',
      ellipsis: true,
      sorter: () => {},
    },
    {
      title: '주문일시',
      width: 160,
      dataIndex: 'createdAt',
      key: 'createdAt',
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = dayjs(value).format('YYYY.MM.DD. HH:mm')
          return date
        }
      },
    },
    {
      title: '상품명',
      width: 200,
      dataIndex: 'productName',
      key: 'productName',
      ellipsis: true,
    },
    {
      title: '옵션명',
      // width: 200,
      dataIndex: 'optionTitle',
      key: 'optionTitle',
      ellipsis: true,
    },
    {
      title: '구매자명',
      width: 90,
      dataIndex: 'createdByName',
      key: 'createdByName',
      ellipsis: true,
    },
    {
      title: '결제일',
      width: 160,
      dataIndex: 'paymentCreatedAt',
      key: 'paymentCreatedAt',
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = dayjs(value).format('YYYY.MM.DD. HH:mm')
          return date
        }
      },
    },
    {
      title: '주문상태',
      width: 90,
      dataIndex: 'orderDetailStatus',
      key: 'orderDetailStatus',
      ellipsis: true,
      render: (value, record) => {
        if (
          Object.prototype.hasOwnProperty.call(record, 'isDeposit') &&
          record.isDeposit &&
          value === 'ready'
        ) {
          return '무통장 입금대기'
        } else {
          return statusUtil.orderStatusChange(value)
        }
      },
    },
    {
      title: '취소 처리상태',
      width: 110,
      dataIndex: 'cancelRequestUser',
      key: 'cancelRequestUser',
      ellipsis: true,
      render: (value, record) => {
        let returnStr = ''
        switch (value) {
          case 'USER':
            returnStr += '구매자 '
            break
          case 'ADMIN':
            returnStr += '관리자 '
        }
        switch (record.orderDetailStatus) {
          case 'cancel_request':
            returnStr += '취소요청'
            break
          case 'cancel_complete':
            returnStr += '취소완료'
            break
        }
        return returnStr
      },
    },
    {
      title: '취소요청일',
      width: 160,
      dataIndex: 'cancelRequestDate',
      key: 'cancelRequestDate',
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = dayjs(value).format('YYYY.MM.DD. HH:mm')
          return date
        } else {
          return value
        }
      },
    },
    {
      title: '취소사유',
      width: 110,
      dataIndex: 'cancelReason',
      key: 'cancelReason',
      ellipsis: true,
    },
    {
      title: '취소승인일',
      width: 160,
      dataIndex: 'cancelApprovalDate',
      key: 'cancelApprovalDate',
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = dayjs(value).format('YYYY.MM.DD. HH:mm')
          return date
        } else {
          return value
        }
      },
    },
    {
      title: '처방전 상태',
      // width: 90,
      dataIndex: 'prescriptionStatus',
      key: 'prescriptionStatus',
      ellipsis: true,
      render: (status) => {
        // null이나 undefined인 경우 처리
        if (status === null || status === undefined) {
          return (
            <Tag
              color="#6D747A"
              style={{
                color: '#FFF',
                fontWeight: 'bold',
                textAlign: 'center',
                justifyContent: 'center',
                // display: 'flex',
              }}
            >
              -
            </Tag>
          )
        }

        const statusConfig = {
          SUBMITTED: { text: '처방전 제출', color: '#F59E0B' },
          PURCHASED: { text: '구매완료', color: '#117FFA' },
          ADMIN_APPROVED: { text: '관리자 승인', color: '#00A4FF' },
          ADMIN_REJECTED: { text: '관리자 반려', color: '#EB516F' },
          REJECTED: { text: '공단 반려', color: '#EB516F' },
          FINALIZED: { text: '최종 완료', color: '#00A4FF' },
        }

        const config = statusConfig[status] || {
          text: status,
          color: '#6D747A',
        }

        return (
          <Tag
            color={config.color}
            style={{ color: '#FFF', fontWeight: 'bold', textAlign: 'center' }}
          >
            {config.text}
          </Tag>
        )
      },
    },
  ]

  useEffect(() => {
    getOrderCancelStatus()
    getDeliveryCompanyList()
  }, [])

  useEffect(() => {
    setOrderList(totalOrderList.slice(offset, offset + pageSize))
  }, [offset, pageSize])

  useEffect(() => {
    handleChangePagination(currentPageNumber)
  }, [pageSize])

  useEffect(() => {
    getUserOrderList()
  }, [orderType, orderBy])

  const getDeliveryCompanyList = async () => {
    setIsLoading(true)
    try {
      const res = await orderApi.deliveryCompanyList(user.id)
      if (res.data.code === 200) {
        setDeliveryCompanyList(res.data.result)
      } else {
        alert(
          '해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.',
        )
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('getDeliveryCompanyList read error', error)
    }
  }

  /**
   * 주문취소 현황 가져오기
   */
  const getOrderCancelStatus = async () => {
    const res = await orderApi.salesManageStatus(null, user.id)
    if (res.data.code === 200) {
      setCancelStatus({
        ...cancelStatus,
        cancelRequest: res.data.result.cancelRequestList?.length ?? 0,
        cancelComplete: res.data.result.cancelCompleteList?.length ?? 0,
        // cancelRequest:
        // 	res.data.result.cancelRequestCnt === null
        // 		? 0
        // 		: res.data.result.cancelRequestCnt,
        // cancelComplete:
        // 	res.data.result.cancelCompleteCnt === null
        // 		? 0
        // 		: res.data.result.cancelCompleteCnt,
      })
    }
  }

  // useEffect(() => {
  //   console.log('fff', selectedRow)
  // }, [selectedRow])

  const getUserOrderList = async (type = '') => {
    setIsLoading(true)
    try {
      let param
      if (type === 'initial') {
        param = {
          offset: 0,
          pageSize: 10,
          pageType: 'cancel',
          searchType: searchDateItems[0].searchType,
          startDate: dayjs()
            .subtract(7, 'days')
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          endDate: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          searchStatus: orderStatusItems[1].value,
          searchOrderId: null,
          searchProductName: '',
          funnel: 0,
          name: '',
          phone: '',
          orderType: 'paymentCreatedAt',
          orderBy: 'desc',
          searchDetailType: '',
          searchDetail: '',
          settlementId: null,
        }
      } else if (type === 'search') {
        param = {
          offset: 0,
          pageSize: 10,
          pageType: 'cancel',
          searchType: searchOptions.searchType,
          startDate: searchOptions.startDate
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          endDate: searchOptions.endDate
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          searchStatus: searchOptions.searchStatus,
          searchOrderId: searchOptions.searchOrderId,
          searchProductName: searchOptions.searchProductName,
          funnel: searchOptions.funnel,
          name: searchOptions.name,
          phone: searchOptions.phone.includes('-')
            ? searchOptions.phone.replaceAll('-', '')
            : searchOptions.phone,
          orderType: orderType,
          orderBy: orderType,
          searchDetailType: '',
          searchDetail: '',
          settlementId: null,
        }
      } else {
        param = {
          offset: offset,
          pageSize: pageSize,
          pageType: 'cancel',
          searchType: searchOptions.searchType,
          startDate: searchOptions.startDate
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          endDate: searchOptions.endDate
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          searchStatus: searchOptions.searchStatus,
          searchOrderId: searchOptions.searchOrderId,
          searchProductName: searchOptions.searchProductName,
          funnel: searchOptions.funnel,
          name: searchOptions.name,
          phone: searchOptions.phone.includes('-')
            ? searchOptions.phone.replaceAll('-', '')
            : searchOptions.phone,
          orderType: orderType,
          orderBy: orderType,
          searchDetailType: '',
          searchDetail: '',
          settlementId: null,
        }
      }
      const res = await orderApi.searchOrderDetailList(param, user.id)
      if (res.data.code === 200) {
        // setTotalOrderList(res.data.result.userOrderDetailDTOList)
        setTotalOrderList([...res.data.result.userOrderDetailDTOList].reverse())
        if (type === 'initial' || type === 'search') {
          // setOrderList(res.data.result.userOrderDetailDTOList.slice(0, 10))
          setOrderList(
            [...res.data.result.userOrderDetailDTOList].reverse().slice(0, 10),
          )
        } else {
          // setOrderList(
          //   res.data.result.userOrderDetailDTOList.slice(
          //     offset,
          //     offset + pageSize,
          //   ),
          // )
          setOrderList(
            [...res.data.result.userOrderDetailDTOList]
              .reverse()
              .slice(offset, offset + pageSize),
          )
        }
        if (res.data.result?.length !== 0) {
          setTotalSize(res.data.result.totalCnt)
        } else {
          setTotalSize(0)
        }
      } else {
        alert(
          '해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.',
        )
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('getUserOrderList read error', error)
    }
  }

  /**
   * handle dateType change
   */
  const handleDateTypeChange = (e) => {
    const value = e.target.value
    setDateType(value)
    switch (value) {
      case 'today':
        setSearchOptions({
          ...searchOptions,
          startDate: dayjs().startOf('day'),
          endDate: dayjs().endOf('day'),
        })
        break
      case '1week':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(7, 'days').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(7, 'days')
              .startOf('day'),
          })
        }
        break
      case '1month':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(1, 'months').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(1, 'months')
              .startOf('day'),
          })
        }
        break
      case '3month':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(3, 'months').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(3, 'months')
              .startOf('day'),
          })
        }
        break
      case '6month':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(6, 'months').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(6, 'months')
              .startOf('day'),
          })
        }
        break
    }
  }

  /**
   * 검색
   */
  const handleSearch = () => {
    if (searchOptions.startDate === null || searchOptions.endDate === null) {
      alert('조회하려는 기간이 없습니다. 다시 설정해주시길 바랍니다.')
    } else {
      if (!searchOptions.startDate.isBefore(searchOptions.endDate)) {
        alert(
          '조회하려는 기간이 잘못 설정되어있습니다. 다시 시도해주시길 바랍니다.',
        )
      } else {
        setOffset(0)
        setCurrentPageNumber(1)
        getUserOrderList('search')
      }
    }
  }

  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      searchType: searchDateItems[0].searchType,
      searchStatus: orderStatusItems[1].value,
      searchOrderId: '',
      searchProductName: '',
      funnel: 0,
      name: '',
      phone: '',
      startDate: dayjs().subtract(7, 'days').startOf('day'),
      endDate: dayjs().endOf('day'),
    })
    setDateType(dateTypeItems[1].value)
    setOffset(0)
    setPageSize(10)
    setSelectedRowKey([])
    setSelectedRow([])
    getUserOrderList('initial')
  }

  /**
   * 취소승인처리 handler
   */
  const handleCancelComplete = async () => {
    setIsLoading(true)
    try {
      const orderList = selectedRow.map((row) => {
        return {
          ...row,
          // ...cancelConfirmReason,
          orderDetailStatus: 'cancel_complete',
          cancelRequestUser: 'ADMIN',
          // shipDate:
          // cancelConfirmReason.shipDate === null
          //     ? dayjs()
          //     : dayjs(cancelConfirmReason.shipDate).format(
          //         'YYYY-MM-DD HH:mm:ss',
          //       ),
        }
      })
      if (selectedRow[0].usePoint !== null) {
        const isLastOrderParam = {
          id: selectedRow[0].orderId,
          orderDetailIdList: selectedRowKey,
        }
        const isLastOrderRes = await orderApi.isLastOrderByOrderId(
          isLastOrderParam,
          user.id,
        )
        if (isLastOrderRes.data.result?.length !== 0) {
          throw `해당 주문은 포인트를 사용힌 주문이라 부분 환불이 불가합니다.\n선택한 주문번호와 동일한 모든 것들을 한번에 선택해서 다시 시도하거나 해당 주문번호와 함께 관리자에게 문의해주시길 바랍니다.`
        }
      }
      if (
        window.confirm(
          `${selectedRow[0].orderId} - [${selectedRow[0].cancelReason}] ${
            selectedRow[0].cancelReasonDetail
              ? selectedRow[0].cancelReasonDetail
              : ''
          } ${
            selectedRow?.length > 1 ? `외 ${selectedRow?.length - 1}건` : ''
          }  의 사유로 취소 요청된 주문입니다.\n해당 주문 건의 취소요청을 승인하시겠습니까?`,
        )
      ) {
        let cancelInfoList = []
        let cancelCouponIdList = []
        let totalPriceSum = 0
        let cancelParam = {}
        let cancelPointParam = {}
        const sellerIdList = [
          ...new Set(selectedRow.map((row) => row.sellerId)),
        ]
        for (const sellerId of sellerIdList) {
          const orderBySeller = selectedRow.filter(
            (row) => row.sellerId === sellerId,
          )
          let isLastOrderParam = {
            sellerId: sellerId,
            id: orderBySeller[0].orderId,
            orderDetailIdList: orderBySeller.map(
              (order) => order.orderDetailId,
            ),
          }
          const isLastOrderRes = await orderApi.isLastOrder(
            isLastOrderParam,
            user.id,
          )
          if (isLastOrderRes.data.code !== 200) {
            throw `서버 오류로 해당 사항을 진행할 수 없습니다. 해당 오류가 계속해서 발생한다면 관리자에게 문의바랍니다.`
          }
          for (const order of orderBySeller) {
            totalPriceSum += order.totalPrice
            if (order.couponId !== null) {
              cancelCouponIdList.push(order.couponId)
            }
            const cancelInfo = {
              orderId: order.orderId,
              orderDetailId: order.orderDetailId,
              orderDetailStatus: 'cancel_complete',
              cancelReason: order.cancelReason,
              cancelReasonDetail: order.cancelReasonDetail,
              cancelRequestUser: order.cancelRequestUser,
              refundHolder:
                order.refundHolder === null ? '' : order.refundHolder,
              refundBank: order.refundBank === null ? '' : order.refundBank,
              refundAccount:
                order.refundAccount === null ? '' : order.refundAccount,
            }
            cancelInfoList.push(cancelInfo)
          }
          if (isLastOrderRes.data.result?.length === 0) {
            if (
              orderBySeller[0].deliveryPriceBaseline !== null &&
              totalPriceSum < orderBySeller[0].deliveryPriceBaseline
            ) {
              totalPriceSum += orderBySeller[0].deliveryPrice
            }
          } else {
            let remainPriceSum = 0
            for (const order of isLastOrderRes.data.result) {
              remainPriceSum += order.totalPrice
            }
            if (
              orderBySeller[0].deliveryPriceBaseline !== null &&
              remainPriceSum < orderBySeller[0].deliveryPriceBaseline
            ) {
              totalPriceSum -= orderBySeller[0].deliveryPrice
            }
          }
        }
        // 포인트 환급
        if (selectedRow[0].usePoint !== null) {
          cancelPointParam = {
            totalOrder: {
              id: selectedRow[0].orderId,
              // order_status: 'cancel_complete',
            },
          }
          totalPriceSum -= selectedRow[0].usePoint
        }
        if (selectedRow[0].payMethod === 'vbank') {
          cancelParam = {
            merchantUid: selectedRow[0].orderId,
            impUid: selectedRow[0].impUid,
            reason: `[${selectedRow[0].cancelReason}] ${selectedRow[0].cancelReasonDetail}`,
            cancelRequestAmount: totalPriceSum,
            refundHolder: selectedRow[0].refundHolder,
            refundBank: selectedRow[0].refundBank,
            refundAccount: selectedRow[0].refundAccount,
            userOrderDetailList: selectedRow,
          }
        } else {
          cancelParam = {
            merchantUid: selectedRow[0].orderId,
            impUid: selectedRow[0].impUid,
            reason: `[${selectedRow[0].cancelReason}] ${selectedRow[0].cancelReasonDetail}`,
            cancelRequestAmount: totalPriceSum,
            userOrderDetailList: selectedRow,
          }
        }
        console.log('ha 머냐', cancelParam)
        const res = await orderApi.orderDirectlyCancel(cancelParam, user.id)
        if (res.data.code === 203) {
          // 쿠폰 관련
          if (cancelCouponIdList?.length !== 0) {
            const cancelCoupon = {
              couponIdList: cancelCouponIdList,
              userCouponIsAvailable: true,
              userId: selectedRow[0].createdBy,
            }
            const cancelCouponRes = await promotionApi.userCouponChangeStatus(
              cancelCoupon,
              user.id,
            )
            if (cancelCouponRes.data.code !== 200) {
              throw `해당 주문건에 대한 쿠폰 정보를 수정하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`
            }
          }
          // 쿠폰 관련 끝
          // 포인트 환급
          if (Object.keys(cancelPointParam)?.length !== 0) {
            const cancelPointRes = await orderApi.purchasePointCancel(
              cancelPointParam,
              user.id,
            )
            if (cancelPointRes.data.code !== 200) {
              throw `해당 주문건에서 사용한 포인트를 환급하는 과정에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`
            }
          }
          for (const cancelInfo of cancelInfoList) {
            const cancelRes = await orderApi.orderCancelInfoEdit(
              cancelInfo,
              user.id,
            )
            if (cancelRes.data.code !== 200) {
              if (cancelRes.data.code === 999) {
                throw cancelRes.data.msg
              } else {
                throw `해당 주문건에 대한 정보를 저장하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`
              }
            }
          }

          const kakaoRes = await pushApi.kakaoForCancelRequestConfirm(
            orderList,
            user.id,
          )
          if (kakaoRes.data.code !== 200) {
            getUserOrderList()
            setTimeout(() => {
              handelCancelRefusalModalCancel()
            }, 1000)
            throw `해당 주문건들에 대한 알림톡을 전송하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`
          }
        } else {
          throw `해당 주문건을 환불하는데 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`
        }

        alert('해당 내용이 성공적으로 반영되었습니다.')
        setSelectedRowKey([])
        setSelectedRow([])
        getUserOrderList()
      }
      setIsLoading(false)
    } catch (e) {
      setIsLoading(false)
      console.log('handleCancelComplete error', e)
      alert(e)
    } finally {
      setIsLoading(false)
    }
  }

  /**
   * excel download
   */
  const handleExcelDownloadClick = () => {
    try {
      let excelData
      if (totalOrderList?.length !== 0) {
        excelData = totalOrderList.map((row) => {
          return {
            orderId: `SG${row.orderId}`,
            orderDetailId: `sg${row.orderDetailId}`,
            paymentCreatedAt: dayjs(row.paymentCreatedAt).format(
              'YYYY.MM.DD HH:mm',
            ),
            orderDetailStatus:
              statusUtil.matchingOrderStatus[row.orderDetailStatus],
            // productId: row.productId,
            productId: `SUG-${row.productId}`,
            productName: row.productName,
            // optionId: row.optionId,
            // optionId: `SUG-${row.optionId}`,
            optionId: `sgot-${row.optionId}`,
            optionTitle: row.optionTitle,
            quantity: row.quantity,
            totalPrice: row.totalPrice,
            price: row.price,
            couponDiscountPrice: row.couponDiscountPrice,
            createdByName: row.createdByName,
            usePoint: row.usePoint ? 'Y' : 'N',
            name: row.name,
            phone: row.phone,
            address: row.address
              ? row.address +
                (row.addressDetail ? `, ${row.addressDetail}` : '')
              : '',
            addressRequest:
              row.addressRequest === '배송 시 요청사항을 선택해주세요.'
                ? ''
                : row.addressRequest,
            deliveryCompany: statusUtil.matchingDeliveryCompany[
              row.deliveryCompany
            ]
              ? statusUtil.matchingDeliveryCompany[row.deliveryCompany]
              : row.deliveryCompany,
            trackingNumber: row.trackingNumber,
            shipDate: row.shipDate
              ? dayjs(row.shipDate).format('YYYY.MM.DD')
              : row.shipDate,
          }
        })
      } else {
        alert(
          '다운받으려는 데이터가 없습니다. 조회 후 다시 시도해주시길 바랍니다.',
        )
        throw 'no data'
      }
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet(excelData)
      Object.keys(excelData[0]).forEach((key, idx) => {
        const cellAdd = XLSX.utils.encode_cell({ c: idx, r: 0 })
        ws[cellAdd].v = statusUtil.matchingKey[key]
      })
      XLSX.utils.book_append_sheet(wb, ws, '주문취소관리')
      XLSX.writeFile(wb, `${dayjs().format('YYYYMMDD')}_주문취소관리.xlsx`)
    } catch (error) {
      setIsLoading(false)
      console.log('handleExcelDownloadClick edit error', error)
    }
  }

  const tableOnChange = (pagination, filters, sorter) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === 'descend') {
          setOrderBy('desc')
        } else if (sorter.order === 'ascend') {
          setOrderBy('asc')
        }
        setOrderType(sorter.field)
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType('paymentCreatedAt')
        setOrderBy('desc')
      }
    }
  }

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber) => {
    const currOffset = (pageNumber - 1) * pageSize
    setCurrentPageNumber(pageNumber)
    setOffset(currOffset)
  }

  /**
   * pageSize 변경 handler
   */
  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize)
    setOffset((current - 1) * pageSize)
  }

  /**
   * 취소거부처리 Modal cancel handler
   */
  const handelCancelRefusalModalCancel = () => {
    setCancelRefusalReason({
      cancelReason: '상품 배송중',
      cancelReasonDetail:
        '고객님, 취소요청하신 상품이 이미 발송되어, 상품 받으신 후에 반품 및 교환만 가능합니다.',
      deliveryCompany: null,
      trackingNumber: '',
      shipDate: dayjs(),
    })
    setIsCancelRefusalModalOpen(false)
  }

  /**
   * 취소거부처리 Modal ok handler
   */
  const handleCancelRefusalModalOk = async () => {
    setIsLoading(true)
    try {
      const valid = handleCancelRefusalValidation()
      if (valid) {
        const orderList = selectedRow.map((row) => {
          return {
            ...row,
            ...cancelRefusalReason,
            orderDetailStatus: 'delivery_shipping',
            cancelRequestUser: 'ADMIN',
            shipDate:
              cancelRefusalReason.shipDate === null
                ? dayjs()
                : dayjs(cancelRefusalReason.shipDate).format(
                    'YYYY-MM-DD HH:mm:ss',
                  ),
          }
        })
        let cancelParam = {
          preOrderDetailStatus: 'cancel_request',
          userOrderDetailDTOList: orderList,
        }
        const res = await orderApi.orderTrackingNumRegister(
          cancelParam,
          user.id,
        )
        const kakaoRes = await pushApi.kakaoForCancelRequestRefusal(
          orderList,
          user.id,
        )
        if (kakaoRes.data.code !== 200) {
          getUserOrderList()
          setTimeout(() => {
            handelCancelRefusalModalCancel()
          }, 1000)
          throw `해당 주문건들에 대한 알림톡을 전송하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`
        }
        setTimeout(() => {
          handelCancelRefusalModalCancel()
        }, 1000)
        getUserOrderList()
        if (res.data.code === 200) {
          alert('해당 내용이 성공적으로 반영되었습니다.')
        } else if (res.data.code === 999 || res.data.code === 405) {
          throw res.data.msg
        } else {
          throw '해당 내용을 수정하는데 실패했습니다. 관리자에게 문의하시길 바랍니다.'
        }
      } else {
        throw '필수값이 채워지지 않았습니다. 다시 시도해주시길 바랍니다.'
      }
    } catch (e) {
      setIsLoading(false)
      console.log('handleCancelRefusal error', e)
      alert(e)
    } finally {
      setIsLoading(false)
    }
  }

  /**
   * 취소거부처리 validation
   */
  const handleCancelRefusalValidation = () => {
    if (
      Object.prototype.hasOwnProperty.call(
        cancelRefusalReason,
        'cancelReason',
      ) &&
      cancelRefusalReason.cancelReason !== null &&
      cancelRefusalReason.cancelReason !== '' &&
      Object.prototype.hasOwnProperty.call(
        cancelRefusalReason,
        'deliveryCompany',
      ) &&
      cancelRefusalReason.deliveryCompany !== null &&
      cancelRefusalReason.deliveryCompany !== '' &&
      Object.prototype.hasOwnProperty.call(
        cancelRefusalReason,
        'trackingNumber',
      ) &&
      cancelRefusalReason.trackingNumber !== null &&
      cancelRefusalReason.trackingNumber !== ''
    ) {
      return true
    } else {
      return false
    }
  }

  const disabledCancelComplete = () => {
    if (selectedRow?.length === 0) {
      return true
      // } else {
      //   let orderId = 0
      //   let validList = []
      //   for (let i = 0; i < selectedRow?.length; i++) {
      //     const row = selectedRow[i]
      //     if (i === 0) {
      //       orderId = row.orderId
      //       if (
      //         Object.prototype.hasOwnProperty.call(row, 'isDeposit') &&
      //         row.isDeposit
      //       ) {
      //         validList.push(false)
      //       } else {
      //         if (
      //           row.orderDetailStatus === 'cancel_request' &&
      //           row.cancelRequestUser !== 'ADMIN'
      //         ) {
      //           validList.push(true)
      //         } else {
      //           validList.push(false)
      //         }
      //       }
      //     } else {
      //       if (row.orderId !== orderId) {
      //         validList.push(false)
      //       } else {
      //         if (
      //           Object.prototype.hasOwnProperty.call(row, 'isDeposit') &&
      //           row.isDeposit
      //         ) {
      //           validList.push(false)
      //         } else {
      //           if (
      //             row.orderDetailStatus === 'cancel_request' &&
      //             row.cancelRequestUser !== 'ADMIN'
      //           ) {
      //             validList.push(true)
      //           } else {
      //             validList.push(false)
      //           }
      //         }
      //       }
      //     }
      //   }
      //   return !validList.every((result) => result)
      // }
    }
  }
  const disabledAdminCancelComplete2 = () => {
    if (selectedRow?.length === 0) {
      return true
    } else {
      let orderId = 0
      let validList = []
      for (let i = 0; i < selectedRow?.length; i++) {
        const row = selectedRow[i]
        if (i === 0) {
          orderId = row.orderId
          if (row.hasOwnProperty('isDeposit') && row.isDeposit) {
            validList.push(true)
          } else {
            if (row.orderDetailStatus === 'paid') {
              validList.push(true)
            } else {
              validList.push(false)
            }
          }
        } else {
          if (row.orderId !== orderId) {
            validList.push(false)
          } else {
            if (row.hasOwnProperty('isDeposit') && row.isDeposit) {
              validList.push(true)
            } else {
              if (row.orderDetailStatus === 'paid') {
                validList.push(true)
              } else {
                validList.push(false)
              }
            }
          }
        }
      }
      return !validList.every((result) => result)
    }
  }

  const checkVbankInfo = () => {
    const refundBankCode = selectedRow[0]?.refundBank
    const refundBankName = Object.keys(kginicisBankCode).find(
      (key) => kginicisBankCode[key] === refundBankCode,
    )

    Swal.fire({
      title: `${selectedRow[0]?.createdByName} (userId : ${selectedRow[0]?.updatedBy})님의 무통장 입금(가상 계좌) 환불 정보입니다.
      계좌 정보에 오류가 있을 경우 포트원에서 직접 취소해주세요.
      
      예금주 성명: ${selectedRow[0]?.refundHolder}
      계좌번호 : ${selectedRow[0]?.refundAccount}
      환불 은행 : ${refundBankName}
      환불 은행 코드 : ${selectedRow[0]?.refundBank}
      `,

      customClass: 'custom-alert',
      // confirmButtonColor: isBestResult ? '#ff4d4f' : '#117ffa',
      confirmButtonText: '확인',
      showCancelButton: true,
      cancelButtonText: '취소',
    })
  }

  const kginicisBankCode = {
    KB국민: '04',
    SC제일: '23',
    경남은행: '39',
    광주: '34',
    IBK기업: '03',
    NH농협: '11',
    'iM뱅크(대구)': '31',
    부산: '32',
    산업은행: '02',
    새마을금고: '45',
    수협: '07',
    신한: '88',
    신협: '48',
    외환은행: '81',
    우리: '20',
    우체국: '71',
    전북: '37',
    축협: '12',
    카카오뱅크: '90',
    케이뱅크: '89',
    하나: '81',
    한국씨티은행: '27',
    토스뱅크: '92',
  }

  const handleMessage = () => {
    return `🚚 상품이 이미 발송되었어요
이미 배송 중인 상품은 취소가 어려워요.
상품을 받으신 뒤에는, 프리스타일 리브레 고객센터에서 교환 및 반품을 도와드리고 있어요.
연락하실 수 있도록 고객센터 정보를 아래에 안내드릴게요.


프리스타일 리브레 고객센터 안내
📞 전화 문의: 080-014-5757
💬 채팅 문의: 카카오톡 → ‘프리스타일 리브레’ 검색
🕒 운영 시간: 평일 8:30 ~ 17:30 (점심 12:00 ~ 13:00 / 주말·공휴일 휴무)`
  }

  // useEffect(() => {
  //   console.log('res', selectedRow)
  // }, [selectedRow])

  return (
    <>
      <ContentHeader title="취소관리" />
      <div className={`${styles['product-register-wrap']}`}>
        {/*취소현황상태*/}
        <Row className={`${styles['product-search-product-status-wrap']}`}>
          {/*취소요청*/}
          <Col span={12} md={5}>
            <Row className={`${styles['product-status-box-wrap']}`}>
              <img
                className={`${styles['product-status-icon']}`}
                src={`${process.env.REACT_APP_HOST}/assets/icon/sales/cancel_request_icon.png`}
              />
              <div className={`${styles['product-status-text']}`}>
                <div>취소요청</div>
                <div>
                  <span className={`${styles['product-status-num']}`}>
                    {cancelStatus.cancelRequest}
                  </span>{' '}
                  건
                </div>
              </div>
            </Row>
          </Col>

          {/*취소완료*/}
          <Col span={12} md={5}>
            <Row className={`${styles['product-status-box-wrap']}`}>
              <img
                className={`${styles['product-status-icon']}`}
                src={`${process.env.REACT_APP_HOST}/assets/icon/sales/cancel_complete_icon.png`}
              />
              <div className={`${styles['product-status-text']}`}>
                <div>취소완료(최근 3일)</div>
                <div>
                  <span className={`${styles['product-status-num']}`}>
                    {cancelStatus.cancelComplete}
                  </span>{' '}
                  건
                </div>
              </div>
            </Row>
          </Col>
        </Row>

        {/*취소현황검색*/}
        <div className={`${styles['product-search-box-wrap']}`}>
          <Form.Item
            label="조회기간"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              value={searchOptions.searchType}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchType: value })
              }
              style={{ width: 120, textAlign: 'left' }}
            >
              {searchDateItems.map((item, idx) => (
                <Select.Option
                  key={`order_date_search_${idx}`}
                  value={item.searchType}
                >
                  {item.searchText}
                </Select.Option>
              ))}
            </Select>
            <ConfigProvider theme={CustomDateButtonRadioTheme}>
              <Row align={'middle'} style={{ marginTop: 10, gap: '5px' }}>
                <Radio.Group
                  className={`${styles['options-list']}`}
                  options={dateTypeItems}
                  onChange={handleDateTypeChange}
                  value={dateType}
                  optionType="button"
                />
                <DatePicker
                  className={`${styles['order-search-date-wrap']}`}
                  format="YYYY/MM/DD"
                  value={searchOptions.startDate}
                  onChange={(value) => {
                    setDateType('')
                    setSearchOptions({ ...searchOptions, startDate: value })
                  }}
                />
                ~
                <DatePicker
                  className={`${styles['order-search-date-wrap']}`}
                  format="YYYY/MM/DD"
                  value={searchOptions.endDate}
                  onChange={(value) => {
                    setDateType('')
                    setSearchOptions({ ...searchOptions, endDate: value })
                  }}
                />
              </Row>
            </ConfigProvider>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Form.Item
            className={`${styles['center-label']}`}
            label="주문상태"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              value={searchOptions.searchStatus}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchStatus: value })
              }
              style={{ width: 250, textAlign: 'left' }}
            >
              {orderStatusItems.map((item, idx) => (
                <Select.Option
                  key={`order_status_search_${idx}`}
                  value={item.value}
                >
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Form.Item
            label="상세검색"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align="middle">
              <Col sm={5} md={2}>
                <div className={`${styles['content-search-wrap']}`}>
                  주문번호
                </div>
              </Col>
              <Col style={{ marginRight: '2rem' }}>
                <Input
                  name="searchOrderId"
                  value={searchOptions.searchOrderId}
                  onChange={(e) => {
                    if (
                      numberReg.test(e.target.value) ||
                      e.target.value === ''
                    ) {
                      setSearchOptions({
                        ...searchOptions,
                        [e.target.name]: e.target.value,
                      })
                    }
                  }}
                  style={{ width: 150, textAlign: 'left' }}
                  onPressEnter={handleSearch}
                />
              </Col>
              <Col sm={5} md={2}>
                <div className={`${styles['content-search-wrap']}`}>상품명</div>
              </Col>
              <Col style={{ marginRight: '2rem' }}>
                <Input
                  name="searchProductName"
                  value={searchOptions.searchProductName}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: 'left' }}
                  onPressEnter={handleSearch}
                />
              </Col>
            </Row>
            <Row align="middle" style={{ marginTop: 10 }}>
              <Col sm={5} md={2}>
                <div className={`${styles['content-search-wrap']}`}>이름</div>
              </Col>
              <Col style={{ marginRight: '2rem' }}>
                <Input
                  name="name"
                  value={searchOptions.name}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: 'left' }}
                  onPressEnter={handleSearch}
                />
              </Col>
              <Col sm={5} md={2}>
                <div className={`${styles['content-search-wrap']}`}>연락처</div>
              </Col>
              <Col>
                <Input
                  name="phone"
                  value={searchOptions.phone}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: 'left' }}
                  onPressEnter={handleSearch}
                />
              </Col>
            </Row>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Row
            className={`${styles['product-search-button-wrap']}`}
            justify="center"
          >
            <Button
              className={`${styles['product-search-button']} ${styles.search}`}
              onClick={handleSearch}
            >
              검색
            </Button>
            <Button
              className={`${styles['product-search-button']} ${styles.initial}`}
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>

        {/*취소목록*/}
        <Row
          className={`${styles['product-register-border-box']}`}
          justify={'space-between'}
          wrap={false}
          style={{ marginTop: 20, borderBottom: 0 }}
        >
          <div>
            <span className={`${styles['product-register-box-title']}`}>
              주문목록 (총{' '}
              <span
                className={`${styles['product-register-box-subtitle']}`}
                style={{ marginLeft: 0 }}
              >
                {totalSize}
              </span>
              개)
            </span>
            <span className={`${styles['product-list-subtitle']}`}>
              {orderPair[orderType]}
            </span>
          </div>
          <div>
            <Button
              className={`${styles['order-excel-download-btn']}`}
              icon={
                <img
                  style={{ height: 14.2, width: 14.5 }}
                  src={`${process.env.REACT_APP_HOST}/assets/icon/common/microsoftexcel.png`}
                />
              }
              onClick={handleExcelDownloadClick}
            >
              엑셀다운
            </Button>
          </div>
        </Row>
        <Row
          className={`${styles['product-register-border-box']}`}
          justify={'space-between'}
          wrap={false}
        >
          <div style={{ gap: 8 }}>
            <Button
              className={`${styles['order-status-change-button']}`}
              disabled={disabledCancelComplete()}
              onClick={() => handleCancelComplete()}
            >
              취소 승인처리
            </Button>
            <Button
              className={`${styles['order-status-change-button']}`}
              disabled={disabledAdminCancelComplete2()}
              onClick={() => checkVbankInfo()}
              style={{ marginLeft: 10 }}
            >
              [주의] 무통장 입금건 취소 계좌 정보
            </Button>
            {/* <Button
              className={`${styles['order-status-change-button']}`}
              disabled={disabledCancelComplete2()}
              onClick={() => handleCancelVbank()}
            >
              무통장 입금 취소
            </Button> */}
          </div>
          <div>
            {/* <Button
              className={`${styles['order-status-change-button']}`}
              disabled
            >
              구매확정 후 취소처리 바로가기
              <img
                style={{ height: 14.2, width: 14.5 }}
                src={`${process.env.REACT_APP_HOST}/assets/icon/sales/right-arrow-gray.png`}
              />
            </Button> */}
          </div>
        </Row>
        <div
          className={`${styles['product-register-border-box']}`}
          style={{
            borderTop: 0,
            borderBottom: 0,
            padding: '20px 25px 40px',
            height: 'fit-content',
          }}
        >
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={orderList}
            loading={isLoading}
            bordered
            size="middle"
            rowKey="orderDetailId"
            rowClassName="coupon-table-row"
            // scroll={{x: 'calc(700px + 50%)'}}
            scroll={{ x: 'max-content' }}
            tableLayout={'auto'}
            onChange={tableOnChange}
            pagination={false}
          />

          <Pagination
            showSizeChanger
            pageSize={pageSize}
            onShowSizeChange={pageSizeChange}
            total={totalSize}
            current={currentPageNumber}
            onChange={handleChangePagination}
            align={'end'}
            style={{ marginTop: 20 }}
          />
        </div>
        <div
          className={`${styles['product-register-border-box']}`}
          style={{
            backgroundColor: '#f8f9fd',
            height: 'fit-content',
            padding: '15px 25px',
          }}
        >
          <Form.Item
            className={`${styles['order-bottom-form-item']} ${styles['center-label']}`}
            label="취소"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align={'middle'} style={{ gap: 10 }}>
              <Button
                className={`${styles['order-status-change-button']}`}
                disabled={disabledCancelComplete()}
                onClick={() => handleCancelComplete()}
              >
                취소 승인처리
              </Button>
              <Button
                className={`${styles['order-status-change-button']}`}
                disabled={disabledCancelComplete()}
                onClick={() => setIsCancelRefusalModalOpen(true)}
              >
                취소 거부처리
              </Button>
            </Row>
          </Form.Item>
        </div>

        {/*취소 거부처리 Modal*/}
        {isCancelRefusalModalOpen && (
          <Modal
            title="취소 거부처리"
            open={isCancelRefusalModalOpen}
            onCancel={handelCancelRefusalModalCancel}
            onOk={handleCancelRefusalModalOk}
            cancelText={<span>닫기</span>}
            okText={<span>확인</span>}
            confirmLoading={isLoading}
            width={'50%'}
          >
            <Form.Item
              label="취소 불가 사유"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Input
                name="cancelReason"
                value={cancelRefusalReason.cancelReason}
                onChange={(e) =>
                  setCancelRefusalReason({
                    ...cancelRefusalReason,
                    [e.target.name]: e.target.value,
                  })
                }
              />
            </Form.Item>
            <Form.Item
              label="구매자에게 전하실 말씀"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              <Input.TextArea
                className="order-modal-address-request-wrap"
                name="cancelReasonDetail"
                value={handleMessage()}
                onChange={(e) =>
                  setCancelRefusalReason({
                    ...cancelRefusalReason,
                    [e.target.name]: e.target.value,
                  })
                }
                rows={10}
              />
            </Form.Item>
            <Form.Item
              label="택배사"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Select
                className="order-delivery-company-select"
                placeholder="선택"
                value={cancelRefusalReason.deliveryCompany}
                onChange={(value) =>
                  setCancelRefusalReason({
                    ...cancelRefusalReason,
                    deliveryCompany: value,
                  })
                }
              >
                {deliveryCompanyList.map((deliveryCompany, idx) => (
                  <Select.Option
                    key={`delivery_company_select_${idx}`}
                    id="delivery_company"
                    value={deliveryCompany.deliveryCompanyId}
                  >
                    {deliveryCompany.deliveryCompanyName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="송장번호"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Input
                name="trackingNumber"
                value={cancelRefusalReason.trackingNumber}
                onChange={(e) =>
                  setCancelRefusalReason({
                    ...cancelRefusalReason,
                    [e.target.name]: e.target.value.trim(),
                  })
                }
              />
            </Form.Item>
            <Form.Item
              label="발송일"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              <DatePicker
                className="order-ship-date-input"
                format="YYYY-MM-DD"
                value={cancelRefusalReason.shipDate}
                onChange={(value) =>
                  setCancelRefusalReason({
                    ...cancelRefusalReason,
                    shipDate: value,
                  })
                }
              />
            </Form.Item>
          </Modal>
        )}
      </div>
    </>
  )
}

export default OrderCancelPage
